/* =====================================================================
   STICKERPACK CONFIGURATOR — CONFIG BLOCK
   Edit the values in here. You should not need to touch anything below
   this block to change pricing, materials, sizes, or delivery estimates.
   ===================================================================== */
window.StickerConfig = {
  // Handle of the Shopify product that holds one variant per
  // Material x Size x Pack combination (see shopify/custom-stickers.csv).
  // Shopify can't change a line's price from the storefront, so the price
  // the customer pays is always the matching variant's price — the
  // multipliers below only drive the instant quote until the product's
  // real prices have loaded. Variant options must be, in order:
  // Material = material.name, Size = size.label, Pack = e.g. '1 sticker', '10 stickers'.
  productHandle: 'custom-stickers',

  // Print resolution for the print / cut files attached to every order.
  printDpi: 300,
  // Background colour runs this far past the cut line in the print files,
  // and the PDF page leaves this much space around the bleed.
  printBleedMm: 1,
  printMarginMm: 2,

  // Cut lines in the RasterLink PDF: spot-colour swatches stroked at 0.25 pt.
  // Die cut: one red line around the sticker (cuts right through).
  // Kiss cut: a green line around the sticker (through the vinyl only) and a
  // red line around the backing square (cuts right through).
  cutLines: {
    through: { name: 'CutContour', cmyk: [0, 1, 1, 0] }, // red
    kiss: { name: 'CutContourKiss', cmyk: [1, 0, 1, 0] }, // green
    strokePt: 0.25,
  },
  // Kiss-cut stickers sit on a backing square this far past the sticker.
  kissBacking: { marginMm: 3, cornerMm: 2 },

  // "Get it by" estimate shown under the price: working days to dispatch,
  // then working days in the post. Weekends are skipped.
  dispatchWorkingDays: 2,
  deliveryWorkingDays: 2,

  cuts: [
    { id: 'die-cut', label: 'Die cut', hint: 'Cut through the backing', multiplier: 1, productHandle: 'custom-stickers' },
    // Kiss cut costs more (a second cut and the backing's extra vinyl), so it
    // has its own product with the same options at these prices.
    { id: 'kiss-cut', label: 'Kiss cut', hint: 'On a backing square', multiplier: 1.1, productHandle: 'custom-stickers-kiss-cut' },
  ],

  // Name of a Pack option value in Shopify ("1 sticker", "100 stickers").
  packLabel: function (qty) {
    return qty.amount + (qty.amount === 1 ? ' sticker' : ' stickers');
  },

  shapes: [
    { id: 'contour', label: 'Custom shape', hint: 'Follows your artwork' },
    { id: 'circle', label: 'Circle' },
    { id: 'oval', label: 'Oval' },
    { id: 'square', label: 'Square' },
    { id: 'rounded-rect', label: 'Rectangle' },
  ],

  materials: [
    { name: 'Premium Vinyl', detail: 'Gloss, waterproof', multiplier: 1, swatch: '#fff', finish: 'gloss', popular: true },
    { name: 'Matte Vinyl', detail: 'Soft-touch, no glare', multiplier: 1, swatch: '#c9c4b8', finish: 'matte' },
    { name: 'Holographic', detail: 'Rainbow shimmer', multiplier: 1.3, swatch: 'linear-gradient(135deg,#d8b4fe,#f9a8d4,#fde68a,#93c5fd)', finish: 'holo' },
    { name: 'Clear', detail: 'See-through vinyl', multiplier: 1.1, swatch: '#dbeafe', finish: 'clear' },
    { name: 'Gold Chrome', detail: 'Mirror gold', multiplier: 1.35, swatch: 'linear-gradient(135deg,#fef3c7,#d4a40b,#fff2a4)', finish: 'chrome' },
  ],

  sizes: [
    { name: 'Small', label: '5 × 5 cm', mm: 50, multiplier: 1 },
    { name: 'Medium', label: '7 × 7 cm', mm: 70, multiplier: 1.35 },
    { name: 'Med-Large', label: '9 × 9 cm', mm: 90, multiplier: 1.7, popular: true },
    { name: 'Large', label: '10 × 10 cm', mm: 100, multiplier: 1.9 },
    { name: 'XL', label: '15 × 15 cm', mm: 150, multiplier: 3 },
  ],

  // Pack price for 5 cm Premium Vinyl (inc. VAT). Every other option is
  // base x material multiplier x size multiplier, rounded by roundPrice.
  // Set 15 Oct 2026 from Sticker Mule / StickerApp UK prices: at least 10%
  // cheaper than both at every size from 50 up (check with
  // node shopify/compare-prices.js), and no minimum order.
  quantities: [
    { amount: 1, base: 2.49 },
    { amount: 10, base: 7.99 },
    { amount: 25, base: 14.99, popular: true },
    { amount: 50, base: 24.99 },
    { amount: 100, base: 39.99 },
    { amount: 250, base: 64.99 },
    { amount: 500, base: 89.99 },
    { amount: 1000, base: 139.99 },
  ],

  // Rounds up to the next price ending in .49 or .99.
  roundPrice: function (x) {
    return Math.ceil(Math.round(x * 200) / 100) / 2 - 0.01;
  },
  // "Save X%" on each pack is the per-sticker saving against this pack.
  savingsBaseIndex: 1,

  // Border = the margin between the artwork and the cut line, in mm at the
  // printed size. Keep thin at 1.5mm or more: cutters drift by about 1mm.
  // Border (mm at the default size). Changing the size scales the whole
  // sticker, border included, so the preview looks the same; the slider
  // then shows the border's real width at the chosen size. Never below
  // minMm: cutters drift by about 1mm.
  border: { minMm: 1.5, maxMm: 15, stepMm: 0.5, defaultMm: 3 },

  // Customers can type their own size (longest side). It is charged at the
  // smallest size band that is at least that big.
  customSize: { minMm: 50, maxMm: 150 },

  // Artwork size slider for every shape except custom shape, in % of
  // "edge to edge": 100% = the artwork reaches the shape's nearest edges.
  // It starts at the size that fits inside the shape with a small margin;
  // above 100% the shape's edge trims the artwork. Customers can also drag
  // the artwork to move it.
  artworkScale: { min: 20, max: 300 },

  // Sticker base colour. Customers only choose the material, so there is
  // just white (add more entries here to bring the colour choice back).
  backgrounds: [
    { id: 'white', label: 'White', color: '#ffffff' },
  ],

  defaultCutId: 'die-cut',
  defaultShapeId: 'contour',

  // Square and rectangle stickers are cut with sharp corners unless the
  // customer picks rounded ones.
  corners: [
    { id: 'square', label: 'Square corners' },
    { id: 'rounded', label: 'Rounded corners' },
  ],
  defaultCornersId: 'square',

  // Artwork checks: when the print team flags a job, the customer gets an email
  // linking to this builder with their order loaded (?reorder=1&...&check=<token>).
  // Their answer goes to this Google Apps Script web app (print-queue/cloud/Code.gs).
  checkUrl: 'https://script.google.com/macros/s/AKfycbzfTmriOhUqkUB3MEjWLw_CUGyUfi15adx_GK5VmE8Vp_K7pMg1VVK2y3V0Kt8KStKX1A/exec',
  defaultMaterialIndex: 0,
  defaultSizeIndex: 2, // 9 cm, the most popular size
  defaultQuantityIndex: 2, // 25: most popular, and at 9 cm it clears free delivery (over £20)
  defaultBackgroundId: 'white',

  // Below this DPI at the selected physical size, warn the customer their
  // upload may print blurry. 150 is a conservative-but-usable floor for
  // sticker printing (professional print work often asks for 300).
  minDpiWarningThreshold: 150,

  // PDF and Illustrator (.ai) files are accepted too, by file type or name.
  acceptedFileTypes: ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml', 'application/pdf'],
  maxFileSizeMb: 20,
};

/* =====================================================================
   IMPLEMENTATION — you shouldn't need to edit below this line.
   ===================================================================== */
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var PREVIEW_PX = 700; // longest side of the on-screen sticker render
  var TRACE_PX = 1000; // die-cut outlines are traced at this size, then scaled

  function initInstance(root) {
    var cfg = window.StickerConfig;
    var q = function (sel) { return root.querySelector(sel); };

    function byId(list, id) {
      return list.filter(function (x) { return x.id === id; })[0] || list[0];
    }

    // Printed size of the sticker's longest side, in mm.
    // The artwork-size slider appears under the preview and in the proof.
    var artScaleWraps = Array.prototype.slice.call(root.querySelectorAll('[data-sp-art-scale-wrap]'));
    var artScaleInputs = Array.prototype.slice.call(root.querySelectorAll('[data-sp-art-scale]'));
    var artScaleValues = Array.prototype.slice.call(root.querySelectorAll('[data-sp-art-scale-value]'));
    var borderWraps = Array.prototype.slice.call(root.querySelectorAll('[data-sp-border-wrap]'));
    var backingLegends = Array.prototype.slice.call(root.querySelectorAll('[data-sp-backing-legend]'));
    function syncArtScale() {
      var pct = state.image && scalableShape() ? layout(1000).pct : (state.artScale || 100);
      artScaleInputs.forEach(function (i) { i.value = pct; });
      artScaleValues.forEach(function (v) { v.textContent = pct + '%'; });
    }

    // Border sliders (under the preview and in the proof), kept in sync.
    var borderInputs = Array.prototype.slice.call(root.querySelectorAll('[data-sp-border]'));
    var borderValues = Array.prototype.slice.call(root.querySelectorAll('[data-sp-border-value]'));
    function syncBorder() {
      var mm = borderMm();
      borderInputs.forEach(function (i) { i.value = mm; });
      borderValues.forEach(function (v) { v.textContent = fmtMm(mm); });
    }

    // Border width in mm at the current size, kept within the slider's range.
    function borderMm() {
      var mm = state.borderRatio * stickerMm();
      return Math.min(cfg.border.maxMm, Math.max(cfg.border.minMm, mm));
    }

    function fmtMm(mm) {
      return (Math.round(mm * 10) / 10) + ' mm';
    }

    function stickerMm() {
      return state.customMm || cfg.sizes[state.sizeIndex].mm;
    }

    function sizeLabel() {
      return state.customMm ? fmtCm(state.customMm) + ' cm (custom)' : cfg.sizes[state.sizeIndex].label;
    }

    function fmtCm(mm) {
      return String(Math.round(mm) / 10);
    }

    // Every shape except custom shape (which is built around the artwork)
    // lets the customer make the artwork bigger or smaller inside it.
    function scalableShape() {
      return state.shapeId !== 'contour';
    }

    var params = new URLSearchParams(window.location.search);
    // Artwork check link from the print team's email (see setupCheck).
    var check = params.get('reorder') && /^[A-Za-z0-9_-]{16,64}$/.test(params.get('check') || '') ? { token: params.get('check') } : null;
    function indexFromParam(name, list, key, fallback) {
      var value = (params.get(name) || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      if (!value) return fallback;
      for (var i = 0; i < list.length; i++) {
        if (String(list[i][key]).toLowerCase().replace(/[^a-z0-9]/g, '') === value) return i;
      }
      return fallback;
    }

    // Material landing pages set data-sp-default-material on the builder.
    function pageMaterialIndex() {
      var name = root.getAttribute('data-sp-default-material');
      for (var i = 0; name && i < cfg.materials.length; i++) {
        if (cfg.materials[i].name === name) return i;
      }
      return cfg.defaultMaterialIndex;
    }

    var state = {
      cutId: cfg.defaultCutId,
      shapeId: cfg.defaultShapeId,
      cornersId: cfg.defaultCornersId,
      materialIndex: indexFromParam('material', cfg.materials, 'name', pageMaterialIndex()),
      sizeIndex: indexFromParam('size', cfg.sizes, 'name', cfg.defaultSizeIndex),
      customMm: null, // set when the customer types their own size
      artScale: null, // artwork size %, null = fits inside (not used by custom shape)
      artOffset: { x: 0, y: 0 }, // artwork moved by dragging, as a fraction of the sticker's width / height
      // Ads can open the builder on a starter pack, e.g. ?size=small&qty=10 (matches the price in the ad).
      quantityIndex: indexFromParam('qty', cfg.quantities, 'amount', cfg.defaultQuantityIndex),
      borderRatio: cfg.border.defaultMm / cfg.sizes[cfg.defaultSizeIndex].mm, // border ÷ sticker size
      backgroundId: cfg.defaultBackgroundId,
      customColor: '#ffffff',
      file: null,
      image: null,
      hasAlpha: false,
      contourCache: {}, // 'borderMm|stickerMm' -> traced outline at TRACE_PX
    };

    var els = {
      dropzone: q('[data-sp-dropzone]'),
      fileInput: q('[data-sp-file-input]'),
      uploadBtn: q('[data-sp-upload-btn]'),
      fileInfo: q('[data-sp-file-info]'),
      canvasWrap: q('[data-sp-canvas-wrap]'),
      previewSticker: q('[data-sp-preview-sticker]'),
      dpiWarning: q('[data-sp-dpi-warning]'),
      cutGrid: q('[data-sp-cut-grid]'),
      shapeGrid: q('[data-sp-shape-grid]'),
      materialGrid: q('[data-sp-material-grid]'),
      sizeGrid: q('[data-sp-size-grid]'),
      customSize: q('[data-sp-custom-size]'),
      customSizeNote: q('[data-sp-custom-size-note]'),
      dims: q('[data-sp-dims]'),
      proofDims: q('[data-sp-proof-dims]'),

      qtyList: q('[data-sp-qty-list]'),
      priceValue: q('[data-sp-price]'),
      priceEach: q('[data-sp-price-each]'),
      delivery: q('[data-sp-delivery]'),
      openProof: q('[data-sp-open-proof]'),
      status: q('[data-sp-status]'),
      proof: q('[data-sp-proof]'),
      proofClose: q('[data-sp-proof-close]'),
      proofSticker: q('[data-sp-proof-sticker]'),
      proofSummary: q('[data-sp-proof-summary]'),
      proofShapes: q('[data-sp-proof-shapes]'),
      proofPrice: q('[data-sp-proof-price]'),
      swap: q('[data-sp-swap]'),
      bgGrid: q('[data-sp-bg-grid]'),
      approve: q('[data-sp-approve]'),
      addOnly: q('[data-sp-add-only]'),
      requestToggle: q('[data-sp-request-toggle]'),
      request: q('[data-sp-request]'),
      notes: q('[data-sp-notes]'),
      proofStatus: q('[data-sp-proof-status]'),
      busy: q('[data-sp-busy]'),
      busyText: q('[data-sp-busy-text]'),
    };

    function gbp(amount) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
    }

    function setStatus(el, message, kind) {
      el.textContent = message || '';
      el.className = 'sp-status' + (kind ? ' sp-' + kind : '');
    }

    // --- Pricing ---------------------------------------------------------
    // Loaded from /products/{handle}.js — the source of truth for prices.
    var variantsByCut = {}; // cut id -> that cut's product variants

    function packLabel(qty) {
      return cfg.packLabel(qty);
    }

    function findVariant(materialIndex, sizeIndex, quantityIndex) {
      var variants = variantsByCut[state.cutId];
      if (!variants) return null;
      var material = cfg.materials[materialIndex].name;
      var size = cfg.sizes[sizeIndex].label;
      var pack = packLabel(cfg.quantities[quantityIndex]);
      return variants.filter(function (v) {
        return v.option1 === material && v.option2 === size && v.option3 === pack;
      })[0] || null;
    }

    function priceFor(quantityIndex) {
      var variant = findVariant(state.materialIndex, state.sizeIndex, quantityIndex);
      if (variant) return variant.price / 100;
      var qty = cfg.quantities[quantityIndex];
      var material = cfg.materials[state.materialIndex];
      var size = cfg.sizes[state.sizeIndex];
      var cut = byId(cfg.cuts, state.cutId);
      return Math.round(cfg.roundPrice(qty.base * material.multiplier * size.multiplier * (cut.multiplier || 1)) * 100) / 100;
    }

    function loadVariants() {
      return Promise.all(cfg.cuts.map(function (cut) {
        return fetch('/products/' + (cut.productHandle || cfg.productHandle) + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Sticker product not found');
            return res.json();
          })
          .then(function (product) {
            variantsByCut[cut.id] = product.variants;
          });
      })).then(renderPrice, function (err) { renderPrice(); throw err; });
    }
    var variantsReady = loadVariants().catch(function () {
      /* Leave the estimated prices showing; addToCart reports the problem. */
    });

    function addWorkingDays(date, days) {
      var d = new Date(date);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    }

    function renderPrice() {
      var price = priceFor(state.quantityIndex);
      var qty = cfg.quantities[state.quantityIndex];
      els.priceValue.textContent = gbp(price);
      els.priceEach.textContent = gbp(price / qty.amount) + ' each';
      els.proofPrice.textContent = gbp(price);

      var baseUnit = priceFor(cfg.savingsBaseIndex) / cfg.quantities[cfg.savingsBaseIndex].amount;
      els.qtyList.innerHTML = '';
      cfg.quantities.forEach(function (q, i) {
        var total = priceFor(i);
        var saving = Math.round((1 - total / q.amount / baseUnit) * 100);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sp-qty-row' + (i === state.quantityIndex ? ' sp-active' : '') + (q.popular ? ' sp-has-popular' : '');
        btn.innerHTML =
          '<b>' + q.amount.toLocaleString('en-GB') + '</b>' +
          '<span>' + gbp(total) + '</span>' +
          (saving >= 5 ? '<em>Save ' + saving + '%</em>' : '<em class="sp-empty"></em>') +
          (q.popular ? '<i class="sp-popular">Most popular</i>' : '');
        btn.addEventListener('click', function () {
          state.quantityIndex = i;
          renderPrice();
        });
        els.qtyList.appendChild(btn);
      });

      var start = new Date();
      // Orders after 2pm count from the next working day.
      if (start.getHours() >= 14) start = addWorkingDays(start, 1);
      var eta = addWorkingDays(start, cfg.dispatchWorkingDays + cfg.deliveryWorkingDays);
      els.delivery.textContent = '🚚 Order today, get it by ' +
        eta.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'short' }) + ' (estimate)';
    }

    // --- Option grids ----------------------------------------------------
    function buildGrid(container, items, isActive, onPick, render) {
      container.innerHTML = '';
      items.forEach(function (item, index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sp-opt';
        render(btn, item, index);
        btn.addEventListener('click', function () { onPick(item, index); });
        container.appendChild(btn);
      });
      container._refresh = function () {
        Array.prototype.forEach.call(container.children, function (el, i) {
          el.classList.toggle('sp-active', isActive(items[i], i));
        });
      };
      container._refresh();
    }

    var grids = [];
    function refreshAll() {
      grids.forEach(function (g) { g._refresh(); });
      renderPrice();
      checkDpi();
      renderPreviews();
    }

    function shapeButton(btn, shape) {
      btn.classList.add('sp-shape-opt');
      btn.innerHTML = '<i class="sp-shape-icon sp-shape-' + shape.id + '"></i><b>' + shape.label + '</b>';
    }

    function buildOptionGrids() {
      buildGrid(els.cutGrid, cfg.cuts, function (c) { return c.id === state.cutId; }, function (c) {
        state.cutId = c.id;
        refreshAll();
      }, function (btn, c) {
        btn.innerHTML = '<b>' + c.label + '</b><span>' + c.hint + '</span>';
      });

      [els.shapeGrid, els.proofShapes].forEach(function (container) {
        buildGrid(container, cfg.shapes, function (s) { return s.id === state.shapeId; }, function (s) {
          state.shapeId = s.id;
          state.artScale = null; // a new shape starts from its own fitted size, centred
          state.artOffset = { x: 0, y: 0 };
          refreshAll();
        }, shapeButton);
      });

      // Corners: a small row under each shape grid, only once Square or
      // Rectangle is picked.
      var cornerGrids = [els.shapeGrid, els.proofShapes].map(function (shapes) {
        var row = document.createElement('div');
        row.className = 'sp-corners';
        row.innerHTML = '<span>Corners</span>';
        var grid = document.createElement('div');
        grid.className = 'sp-corner-grid';
        row.appendChild(grid);
        shapes.parentNode.insertBefore(row, shapes.nextSibling);
        buildGrid(grid, cfg.corners, function (c) { return c.id === state.cornersId; }, function (c) {
          state.cornersId = c.id;
          refreshAll();
        }, function (btn, c) {
          btn.classList.add('sp-corner-opt');
          btn.innerHTML = '<i class="sp-corner-icon sp-corner-' + c.id + '"></i><b>' + c.label.replace(' corners', '') + '</b>';
        });
        var refresh = grid._refresh;
        grid._refresh = function () {
          row.hidden = !cornerChoice();
          refresh();
        };
        grid._refresh();
        return grid;
      });

      buildGrid(els.materialGrid, cfg.materials, function (m, i) { return i === state.materialIndex; }, function (m, i) {
        state.materialIndex = i;
        refreshAll();
      }, function (btn, m) {
        btn.classList.add('sp-material-opt');
        btn.innerHTML = '<i class="sp-swatch" style="background:' + m.swatch + '"></i><b>' + m.name + '</b><span>' + m.detail + '</span>' +
          (m.popular ? '<em class="sp-popular">Most popular</em>' : '');
        if (m.popular) btn.classList.add('sp-has-popular');
      });

      buildGrid(els.sizeGrid, cfg.sizes, function (s, i) { return i === state.sizeIndex && !state.customMm; }, function (s, i) {
        state.sizeIndex = i;
        state.customMm = null;
        els.customSize.value = '';
        els.customSizeNote.textContent = '';
        refreshAll();
      }, function (btn, s) {
        btn.innerHTML = '<b>' + s.label + '</b><span>' + s.name + '</span>' +
          (s.popular ? '<em class="sp-popular">Most popular</em>' : '');
        if (s.popular) btn.classList.add('sp-has-popular');
      });

      buildGrid(els.bgGrid, cfg.backgrounds, function (bg) { return bg.id === state.backgroundId; }, function (bg) {
        state.backgroundId = bg.id;
        if (bg.id === 'custom') colorInput.click();
        refreshAll();
      }, function (btn, bg) {
        btn.classList.add('sp-bg-opt');
        btn.title = bg.label;
        btn.setAttribute('aria-label', bg.label);
        btn.innerHTML = '<i style="background:' + (bg.color || 'conic-gradient(red,yellow,lime,cyan,blue,magenta,red)') + '"></i>';
      });

      grids = [els.cutGrid, els.shapeGrid, els.proofShapes, els.materialGrid, els.sizeGrid, els.bgGrid].concat(cornerGrids);
    }

    var colorInput = document.createElement('input');
    colorInput.type = 'color';
    colorInput.value = state.customColor;
    colorInput.className = 'sp-color-input';
    colorInput.addEventListener('input', function () {
      state.customColor = colorInput.value;
      state.backgroundId = 'custom';
      refreshAll();
    });
    els.bgGrid.parentNode.insertBefore(colorInput, els.bgGrid.nextSibling);
    var bgBlock = root.querySelector('[data-sp-bg-block]');
    if (bgBlock) bgBlock.hidden = cfg.backgrounds.length < 2;

    function backgroundColor() {
      var bg = byId(cfg.backgrounds, state.backgroundId);
      return bg.id === 'custom' ? state.customColor : bg.color;
    }

    // --- DPI check -------------------------------------------------------
    function checkDpi() {
      if (!state.image || isVector(state.file)) {
        els.dpiWarning.classList.remove('sp-visible');
        return;
      }
      var inches = stickerMm() / 25.4;
      var dpi = Math.max(state.original.naturalWidth, state.original.naturalHeight) / inches;
      if (dpi < cfg.minDpiWarningThreshold) {
        els.dpiWarning.classList.add('sp-visible');
        els.dpiWarning.textContent =
          '⚠ This image is roughly ' + Math.round(dpi) + ' DPI at ' + sizeLabel() +
          '. It may look soft when printed. Try a larger image or a smaller size.';
      } else {
        els.dpiWarning.classList.remove('sp-visible');
      }
    }

    // --- PDF / Illustrator uploads ---------------------------------------
    // Browsers can't draw PDFs, so page 1 is rendered with pdf.js (loaded
    // only when someone uploads one) at print resolution, with a
    // transparent background so the cut line can follow the design. Most
    // .ai files are PDF-compatible and open the same way.
    var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
    var pdfjsReady = null;

    function loadPdfJs() {
      if (!pdfjsReady) {
        pdfjsReady = new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = PDFJS + 'pdf.min.js';
          s.onload = function () {
            window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
            resolve(window.pdfjsLib);
          };
          s.onerror = function () { pdfjsReady = null; reject(new Error('Could not load the PDF reader')); };
          document.head.appendChild(s);
        });
      }
      return pdfjsReady;
    }

    function isPdfLike(file) {
      return file.type === 'application/pdf' || /\.(pdf|ai)$/i.test(file.name);
    }

    function isVector(file) {
      return file.type === 'image/svg+xml' || isPdfLike(file);
    }

    // Renders page 1 big enough for the largest sticker at print DPI,
    // trimmed to the design. Resolves { image, pages }.
    function pdfToImage(file) {
      return loadPdfJs().then(function (pdfjsLib) {
        return file.arrayBuffer().then(function (buf) {
          return pdfjsLib.getDocument({ data: new Uint8Array(buf) }).promise;
        }).then(function (pdf) {
          return pdf.getPage(1).then(function (page) {
            var base = page.getViewport({ scale: 1 });
            var targetPx = cfg.customSize.maxMm / 25.4 * cfg.printDpi * 1.25;
            var vp = page.getViewport({ scale: Math.min(20, targetPx / Math.max(base.width, base.height)) });
            var c = document.createElement('canvas');
            c.width = Math.ceil(vp.width);
            c.height = Math.ceil(vp.height);
            return page.render({ canvasContext: c.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise
              .then(function () { return canvasToImage(trimCanvas(c)); })
              .then(function (image) { return { image: image, pages: pdf.numPages }; });
          });
        });
      });
    }

    // --- Upload ----------------------------------------------------------
    function handleFile(file) {
      if (!file) return;
      if (cfg.acceptedFileTypes.indexOf(file.type) === -1 && !isPdfLike(file)) {
        setStatus(els.status, 'Please upload a PNG, JPG, WebP, SVG, PDF or AI file.', 'error');
        return;
      }
      if (file.size > cfg.maxFileSizeMb * 1024 * 1024) {
        setStatus(els.status, 'That file is larger than ' + cfg.maxFileSizeMb + 'MB. Try a smaller export.', 'error');
        return;
      }
      var pageNote = '';

      if (isPdfLike(file)) {
        setStatus(els.status, 'Reading your ' + (/\.ai$/i.test(file.name) ? 'Illustrator' : 'PDF') + ' file…', '');
        pdfToImage(file).then(function (r) {
          pageNote = r.pages > 1 ? ' · page 1 of ' + r.pages + ' used' : '';
          useImage(r.image);
          if (r.pages > 1) setStatus(els.status, 'Your file has ' + r.pages + ' pages, so we\'ve used the first one. Upload one design per sticker.', '');
        }).catch(function () {
          setStatus(els.status, /\.ai$/i.test(file.name)
            ? 'We couldn\'t read that Illustrator file. Save it with "Create PDF Compatible File" ticked, or export a PDF or PNG.'
            : 'We couldn\'t read that PDF. Try exporting it again, or upload a PNG.', 'error');
        });
        return;
      }

      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        if (!img.naturalWidth) {
          setStatus(els.status, 'Could not read the size of that image. Try a PNG export.', 'error');
          return;
        }
        // Empty transparent space around the design would otherwise count
        // as part of the sticker, printing the design smaller than ordered.
        if (detectAlpha(img) || file.type === 'image/svg+xml') {
          trimToContent(img, file.type === 'image/svg+xml').then(function (trimmed) { useImage(trimmed); });
        } else {
          useImage(img);
        }
      };

      function useImage(img) {
        state.file = file;
        state.original = img;
        state.image = img;
        state.cutout = null;
        state.useCutout = false;
        state.hasAlpha = detectAlpha(img);
        state.contourCache = {};
        state.artScale = state.pendingArtScale || null; // set by a reorder link
        state.pendingArtScale = null;
        state.artOffset = state.pendingArtOffset || { x: 0, y: 0 };
        state.pendingArtOffset = null;
        var wantCutout = state.pendingCutout !== '0'; // a reorder link can say the background wasn't removed
        state.pendingCutout = null;
        syncArtScale();
        setStatus(els.status, state.reorderNote ? 'Your previous design is loaded with the same options. Change anything you like, then see your proof.' : '', state.reorderNote ? 'ok' : '');
        state.reorderNote = false;
        bgToggles.forEach(function (t) { t.hidden = true; });
        if (!state.hasAlpha) {
          removeBackground(img).then(function (cutout) {
            if (state.original !== img) return; // a newer file was picked meanwhile
            state.cutout = cutout;
            bgToggles.forEach(function (t) {
              t.hidden = false;
              t.classList.toggle('sp-disabled', !cutout);
              t.querySelector('input').disabled = !cutout;
              t.querySelector('span').innerHTML = cutout
                ? 'Remove the background so the border follows my design' +
                  '<small class="sp-bg-hint">Removal is automatic, so check your proof for any leftover background.</small>'
                : 'This image has a detailed background we can\'t remove automatically, so the cut follows its rectangle. A transparent PNG gives a shaped border.';
            });
            if (cutout) setUseCutout(wantCutout);
          });
        }
        els.dropzone.hidden = true;
        els.canvasWrap.hidden = false;
        els.fileInfo.hidden = false;
        var kind = isPdfLike(file) ? (/\.ai$/i.test(file.name) ? 'AI' : 'PDF') : (file.type.split('/')[1] || '').replace('svg+xml', 'svg').toUpperCase();
        els.fileInfo.innerHTML =
          '<b>' + escapeHtml(file.name) + '</b><span>' + kind +
          (isVector(file) ? ' · vector' + pageNote : ' · ' + img.naturalWidth + ' × ' + img.naturalHeight + 'px') + '</span>';
        els.uploadBtn.textContent = 'Change file';
        els.openProof.disabled = false;
        els.openProof.textContent = 'See your proof →';
        checkDpi();
        renderPreviews();
      }
      img.onerror = function () {
        setStatus(els.status, 'Could not read that image. Try a different file.', 'error');
      };
      img.src = url;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // --- Background removal ---------------------------------------------
    // For opaque uploads (logo on white, design on a flat colour): find the
    // background colour from the image's edges, flood-fill it away from the
    // edges inward, and return the cut-out as a new image. Busy or
    // photographic backgrounds are left alone (resolves null).
    var CUTOUT_MAX_PX = 2400;

    function removeBackground(img) {
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(cutOutBackground(img)); }, 30);
      }).then(function (canvas) {
        if (!canvas) return null;
        canvas = trimCanvas(canvas);
        return canvasToBlob(canvas, 'image/png').then(function (blob) {
          return new Promise(function (resolve) {
            var out = new Image();
            out.onload = function () { resolve(out); };
            out.onerror = function () { resolve(null); };
            out.src = URL.createObjectURL(blob);
          });
        });
      }).catch(function () { return null; });
    }

    // Crops a canvas to the box around its visible design (pixels at least
    // half opaque). Returns the same canvas when there is nothing to trim.
    function trimCanvas(c) {
      var w = c.width, h = c.height;
      var d = c.getContext('2d').getImageData(0, 0, w, h).data;
      var minX = w, minY = h, maxX = -1, maxY = -1;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          if (d[(y * w + x) * 4 + 3] >= 128) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0 || (minX === 0 && minY === 0 && maxX === w - 1 && maxY === h - 1)) return c;
      var out = document.createElement('canvas');
      out.width = maxX - minX + 1;
      out.height = maxY - minY + 1;
      out.getContext('2d').drawImage(c, minX, minY, out.width, out.height, 0, 0, out.width, out.height);
      return out;
    }

    function canvasToImage(c) {
      return canvasToBlob(c, 'image/png').then(function (blob) {
        return new Promise(function (resolve, reject) {
          var out = new Image();
          out.onload = function () { resolve(out); };
          out.onerror = reject;
          out.src = URL.createObjectURL(blob);
        });
      });
    }

    // Trimmed copy of an uploaded image. SVGs are drawn at a print-ready
    // size first (big enough for a 15 cm sticker at 300 DPI).
    function trimToContent(img, isSvg) {
      var longest = Math.max(img.naturalWidth, img.naturalHeight);
      var scale = isSvg ? 2400 / longest : Math.min(1, 4000 / longest);
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.naturalWidth * scale));
      c.height = Math.max(1, Math.round(img.naturalHeight * scale));
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      var t = trimCanvas(c);
      if (t === c && scale === 1) return Promise.resolve(img);
      return canvasToImage(t).catch(function () { return img; });
    }

    function cutOutBackground(img) {
      var scale = Math.min(1, CUTOUT_MAX_PX / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      var w = c.width = Math.max(1, Math.round(img.naturalWidth * scale));
      var h = c.height = Math.max(1, Math.round(img.naturalHeight * scale));
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var imageData = ctx.getImageData(0, 0, w, h);
      var d = imageData.data;

      // Background colour = per-channel median of the edge pixels.
      var edge = [];
      var x, y, i;
      for (x = 0; x < w; x++) { edge.push(x, (h - 1) * w + x); }
      for (y = 1; y < h - 1; y++) { edge.push(y * w, y * w + w - 1); }
      function median(ch) {
        var v = edge.map(function (p) { return d[p * 4 + ch]; }).sort(function (a, b) { return a - b; });
        return v[v.length >> 1];
      }
      var bg = [median(0), median(1), median(2)];
      function dist(p) {
        var o = p * 4, dr = d[o] - bg[0], dg = d[o + 1] - bg[1], db = d[o + 2] - bg[2];
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }

      // Only a plain background: most of the edge must match it.
      var TOL = 48;
      var matching = edge.filter(function (p) { return dist(p) < TOL; }).length;
      if (matching / edge.length < 0.7) return null;

      // Flood fill from every matching edge pixel.
      var isBg = new Uint8Array(w * h);
      var queue = new Int32Array(w * h);
      var head = 0, tail = 0;
      edge.forEach(function (p) {
        if (!isBg[p] && dist(p) < TOL) { isBg[p] = 1; queue[tail++] = p; }
      });
      while (head < tail) {
        var p = queue[head++];
        var px = p % w, py = (p - px) / w;
        var nb = [px > 0 ? p - 1 : -1, px < w - 1 ? p + 1 : -1, py > 0 ? p - w : -1, py < h - 1 ? p + w : -1];
        for (i = 0; i < 4; i++) {
          var n = nb[i];
          if (n >= 0 && !isBg[n] && dist(n) < TOL) { isBg[n] = 1; queue[tail++] = n; }
        }
      }

      var removed = tail / (w * h);
      if (removed < 0.03 || removed > 0.97) return null;

      // Clear the background; soften the 1px rim next to it so edges
      // (anti-aliased against the old background) don't leave a halo.
      for (i = 0; i < w * h; i++) {
        if (isBg[i]) { d[i * 4 + 3] = 0; continue; }
        var ix = i % w;
        var touches = (ix > 0 && isBg[i - 1]) || (ix < w - 1 && isBg[i + 1]) || (i >= w && isBg[i - w]) || (i < w * (h - 1) && isBg[i + w]);
        if (touches) {
          var t = Math.min(1, dist(i) / (TOL * 2.5));
          d[i * 4 + 3] = Math.round(d[i * 4 + 3] * t);
        }
      }
      ctx.putImageData(imageData, 0, 0);
      return c;
    }

    var bgToggles = Array.prototype.slice.call(root.querySelectorAll('[data-sp-bg-toggle]'));

    // The pinned preview block can be taller than the window. Pin it by its
    // bottom edge then, so the sliders and tick box under the preview stay reachable.
    var previewInner = root.querySelector('.sp-preview-inner');
    if (previewInner) {
      var setPinTop = function () {
        previewInner.style.top = Math.min(24, window.innerHeight - previewInner.offsetHeight - 24) + 'px';
      };
      if (window.ResizeObserver) new ResizeObserver(setPinTop).observe(previewInner);
      window.addEventListener('resize', setPinTop);
      setPinTop();
    }

    function setUseCutout(on) {
      state.useCutout = !!(on && state.cutout);
      state.image = state.useCutout ? state.cutout : state.original;
      state.hasAlpha = state.useCutout || detectAlpha(state.original);
      state.contourCache = {};
      bgToggles.forEach(function (t) { t.querySelector('input').checked = state.useCutout; });
      renderPreviews();
    }

    bgToggles.forEach(function (t) {
      t.querySelector('input').addEventListener('change', function (e) { setUseCutout(e.target.checked); });
    });

    function detectAlpha(img) {
      var c = document.createElement('canvas');
      var scale = Math.min(1, 300 / Math.max(img.naturalWidth, img.naturalHeight));
      c.width = Math.max(1, Math.round(img.naturalWidth * scale));
      c.height = Math.max(1, Math.round(img.naturalHeight * scale));
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, c.width, c.height);
      var data = ctx.getImageData(0, 0, c.width, c.height).data;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] < 250) return true;
      }
      return false;
    }

    // --- Sticker geometry + rendering -----------------------------------
    // Everything is laid out on a canvas whose longest side is `long` px —
    // the whole sticker including its border, i.e. the size it is cut at.
    function effectiveShape() {
      return state.shapeId === 'contour' && !state.hasAlpha ? 'rounded-rect' : state.shapeId;
    }

    // Square and rectangle (including custom shape's rectangle fallback) can
    // have square or rounded corners.
    function hasCorners() {
      var shape = effectiveShape();
      return shape === 'square' || shape === 'rounded-rect';
    }

    // The corner choice is only offered for Square and Rectangle; custom
    // shape's rectangle fallback is always cut with square corners.
    function cornerChoice() {
      return state.shapeId === 'square' || state.shapeId === 'rounded-rect';
    }

    function rounded() {
      return cornerChoice() && state.cornersId === 'rounded';
    }

    // The artwork is only ever scaled evenly (never stretched). Custom shape
    // is built around the artwork with the border slider. Every other shape
    // is the cut line itself: the artwork-size slider goes from smaller,
    // through "fits inside with a small margin" (the starting point), up to
    // "fills the whole shape" (no white; the shape's edge trims it).
    function layout(long) {
      var img = state.image;
      var iw = img.naturalWidth, ih = img.naturalHeight;
      var shape = effectiveShape();
      var b = state.shapeId === 'contour' // custom shape (or its rectangle fallback) uses the border slider
        ? borderMm() / stickerMm() * long
        : cfg.border.defaultMm / cfg.sizes[cfg.defaultSizeIndex].mm * long; // fixed margin for the "fits" size
      var w, h, k;
      var inner = long - 2 * b;

      if (shape === 'square') {
        w = h = long;
        k = Math.min(inner / iw, inner / ih);
      } else if (shape === 'circle') {
        w = h = long;
        // artwork corners touch the circle inset by the margin
        k = inner / Math.sqrt(iw * iw + ih * ih);
      } else if (shape === 'oval') {
        // a fixed 4:3 oval, turned to match the artwork's orientation
        if (iw >= ih) { w = long; h = long * 0.75; } else { h = long; w = long * 0.75; }
        var A = (w - 2 * b) / 2, B = (h - 2 * b) / 2;
        // largest artwork whose corners sit on the inset ellipse
        k = 1 / Math.sqrt(Math.pow(iw / (2 * A), 2) + Math.pow(ih / (2 * B), 2));
      } else {
        // contour + rectangle: the shape is built around the artwork
        k = inner / Math.max(iw, ih);
        w = iw * k + 2 * b;
        h = ih * k + 2 * b;
      }

      var pct = 100, ox = 0, oy = 0;
      if (scalableShape()) {
        var kEdge = Math.min(w / iw, h / ih); // 100%: the artwork reaches the nearest edges
        pct = state.artScale == null ? Math.round(k / kEdge * 100) : state.artScale;
        k = kEdge * pct / 100;
        ox = state.artOffset.x * w;
        oy = state.artOffset.y * h;
      }
      var artW = iw * k, artH = ih * k;
      return { w: w, h: h, b: b, shape: shape, pct: pct, artX: (w - artW) / 2 + ox, artY: (h - artH) / 2 + oy, artW: artW, artH: artH };
    }

    function contourPoints(long) {
      var cacheKey = borderMm().toFixed(2) + '|' + stickerMm();
      var cached = state.contourCache[cacheKey];
      if (!cached) {
        var L = layout(TRACE_PX);
        var pad = 4 + Math.ceil(L.b); // room for the smoothing blur
        var c = document.createElement('canvas');
        c.width = Math.ceil(L.w) + pad * 2;
        c.height = Math.ceil(L.h) + pad * 2;
        var ctx = c.getContext('2d');
        // Hard-edged silhouette first: only pixels at least half opaque count
        // as the design, so soft drop shadows and glows don't push the cut
        // line out (stamped many times, a faint shadow would add up to solid).
        var sil = document.createElement('canvas');
        sil.width = Math.max(1, Math.round(L.artW));
        sil.height = Math.max(1, Math.round(L.artH));
        var sctx = sil.getContext('2d');
        sctx.drawImage(state.image, 0, 0, sil.width, sil.height);
        var silData = sctx.getImageData(0, 0, sil.width, sil.height);
        // Clean the outline first: a light blur-and-threshold removes stray
        // specks and paper-texture noise around the edge, which would each
        // become a bump once the border is added.
        smoothAlpha(silData, Math.max(1.5, sil.width / 250));
        sctx.putImageData(silData, 0, 0);
        // Dilate the silhouette by the border width: stamp it around a
        // circle of radius b. The union's outer edge is the cut line.
        // Enough stamps that sharp points (stars etc.) don't leave spikes.
        var steps = 96;
        for (var i = 0; i <= steps; i++) {
          var a = (i / steps) * Math.PI * 2;
          var r = i === steps ? 0 : L.b;
          ctx.drawImage(sil, pad + L.artX + Math.cos(a) * r, pad + L.artY + Math.sin(a) * r, L.artW, L.artH);
        }
        // Smooth the bordered shape: blur-and-threshold rounds off bumps and
        // fills notches narrower than about half the border, like a real
        // cutter would, while straight edges stay where they are.
        var dilated = ctx.getImageData(0, 0, c.width, c.height);
        for (var j = 3; j < dilated.data.length; j += 4) dilated.data[j] = dilated.data[j] >= 24 ? 255 : 0;
        smoothAlpha(dilated, Math.max(3, L.b * 0.9));
        // Safety net: the smoothed line may never come closer to the artwork
        // than half the border (so a thin point can't get cut through).
        var inner = document.createElement('canvas');
        inner.width = c.width;
        inner.height = c.height;
        var ictx = inner.getContext('2d');
        for (var s = 0; s <= steps; s++) {
          var ang = (s / steps) * Math.PI * 2;
          var ir = s === steps ? 0 : L.b * 0.5;
          ictx.drawImage(sil, pad + L.artX + Math.cos(ang) * ir, pad + L.artY + Math.sin(ang) * ir, L.artW, L.artH);
        }
        var innerData = ictx.getImageData(0, 0, c.width, c.height).data;
        for (var m = 3; m < dilated.data.length; m += 4) if (innerData[m] >= 24) dilated.data[m] = 255;
        // Designs in separate pieces (two words, a logo and a tagline...): if
        // the border doesn't join them, the cut wraps all of them in one
        // smooth outline instead of keeping only the biggest piece.
        var outline = separatePieces(dilated)
          ? hullOutline(dilated)
          : window.ContourTrace.trace(dilated, { alphaThreshold: 128, simplifyTolerance: 1.5, offset: 0 }).points;
        cached = {
          points: chaikin(chaikin(outline)).map(function (p) { return { x: p.x - pad, y: p.y - pad }; }),
        };
        state.contourCache[cacheKey] = cached;
      }
      var k = long / TRACE_PX;
      return cached.points.map(function (p) { return { x: p.x * k, y: p.y * k }; });
    }

    // Blur the alpha channel (three box-blur passes, close to a Gaussian of
    // the given radius) and threshold it back to solid/clear at 50%. Shapes
    // keep their size; anything finer than the radius is smoothed away.
    function smoothAlpha(imageData, radius) {
      var w = imageData.width, h = imageData.height, d = imageData.data;
      var a = new Float32Array(w * h), tmp = new Float32Array(w * h);
      for (var i = 0; i < w * h; i++) a[i] = d[i * 4 + 3] >= 128 ? 1 : 0;
      var r = Math.max(1, Math.round(radius / 1.7));
      for (var pass = 0; pass < 3; pass++) {
        boxBlur(a, tmp, w, h, r, true);
        boxBlur(tmp, a, w, h, r, false);
      }
      for (var k = 0; k < w * h; k++) d[k * 4 + 3] = a[k] >= 0.5 ? 255 : 0;
    }

    // One box-blur pass along rows (horizontal) or columns, src -> dst.
    function boxBlur(src, dst, w, h, r, horizontal) {
      var lines = horizontal ? h : w, len = horizontal ? w : h;
      var step = horizontal ? 1 : w, size = 2 * r + 1;
      for (var l = 0; l < lines; l++) {
        var base = horizontal ? l * w : l, sum = 0, i;
        for (i = -r; i <= r; i++) sum += src[base + Math.min(len - 1, Math.max(0, i)) * step];
        for (i = 0; i < len; i++) {
          dst[base + i * step] = sum / size;
          sum += src[base + Math.min(len - 1, i + r + 1) * step] - src[base + Math.max(0, i - r) * step];
        }
      }
    }

    // True when the solid areas of a mask form more than one real piece
    // (pieces under 0.5% of the total, like stray specks, don't count).
    function separatePieces(imageData) {
      var w = imageData.width, h = imageData.height, d = imageData.data;
      var seen = new Uint8Array(w * h), sizes = [], total = 0, stack = [];
      for (var start = 0; start < w * h; start++) {
        if (seen[start] || d[start * 4 + 3] < 128) continue;
        var size = 0;
        stack.push(start);
        seen[start] = 1;
        while (stack.length) {
          var i = stack.pop(), x = i % w, y = (i - x) / w;
          size++;
          if (x > 0 && !seen[i - 1] && d[(i - 1) * 4 + 3] >= 128) { seen[i - 1] = 1; stack.push(i - 1); }
          if (x < w - 1 && !seen[i + 1] && d[(i + 1) * 4 + 3] >= 128) { seen[i + 1] = 1; stack.push(i + 1); }
          if (y > 0 && !seen[i - w] && d[(i - w) * 4 + 3] >= 128) { seen[i - w] = 1; stack.push(i - w); }
          if (y < h - 1 && !seen[i + w] && d[(i + w) * 4 + 3] >= 128) { seen[i + w] = 1; stack.push(i + w); }
        }
        sizes.push(size);
        total += size;
      }
      return sizes.filter(function (sz) { return sz > total * 0.005; }).length > 1;
    }

    // Convex outline around every solid pixel of a mask (from each row's
    // leftmost and rightmost pixels), as a closed polygon.
    function hullOutline(imageData) {
      var w = imageData.width, h = imageData.height, d = imageData.data, pts = [];
      for (var y = 0; y < h; y++) {
        var left = -1, right = -1;
        for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] >= 128) { if (left < 0) left = x; right = x; }
        if (left >= 0) { pts.push({ x: left, y: y }); pts.push({ x: right + 1, y: y }); }
      }
      pts.sort(function (a, b) { return a.x - b.x || a.y - b.y; });
      var cross = function (o, a, b) { return (a.x - o.x) * (b.y - o.y) - (a.y - o.y) * (b.x - o.x); };
      var lower = [], upper = [];
      for (var i = 0; i < pts.length; i++) {
        while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], pts[i]) <= 0) lower.pop();
        lower.push(pts[i]);
      }
      for (var j = pts.length - 1; j >= 0; j--) {
        while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], pts[j]) <= 0) upper.pop();
        upper.push(pts[j]);
      }
      return lower.slice(0, -1).concat(upper.slice(0, -1));
    }

    // Chaikin corner cutting on a closed polygon: turns the traced outline
    // into smooth curves without moving it noticeably.
    function chaikin(pts) {
      if (pts.length < 3) return pts;
      var out = [];
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i], q = pts[(i + 1) % pts.length];
        out.push({ x: p.x * 0.75 + q.x * 0.25, y: p.y * 0.75 + q.y * 0.25 });
        out.push({ x: p.x * 0.25 + q.x * 0.75, y: p.y * 0.25 + q.y * 0.75 });
      }
      return out;
    }

    function round(n) { return Math.round(n * 100) / 100; }

    function cutPath(L, long) {
      var w = L.w, h = L.h;
      switch (L.shape) {
        case 'contour': {
          var pts = contourPoints(long);
          if (!pts.length) return rectPath(w, h, rounded() ? Math.min(w, h) * 0.08 : 0);
          return 'M ' + pts.map(function (p) { return round(p.x) + ' ' + round(p.y); }).join(' L ') + ' Z';
        }
        case 'circle':
        case 'oval': {
          var rx = w / 2, ry = h / 2;
          return 'M 0 ' + round(ry) + ' A ' + round(rx) + ' ' + round(ry) + ' 0 1 0 ' + round(w) + ' ' + round(ry) +
            ' A ' + round(rx) + ' ' + round(ry) + ' 0 1 0 0 ' + round(ry) + ' Z';
        }
        case 'square':
          return rectPath(w, h, rounded() ? Math.min(w, h) * 0.04 : 0);
        default:
          return rectPath(w, h, rounded() ? Math.min(w, h) * 0.08 : 0);
      }
    }

    function rectPath(w, h, r) {
      return rectPathAt(0, 0, w, h, r);
    }

    function rectPathAt(x, y, w, h, r) {
      var x0 = round(x), y0 = round(y), x1 = round(x + w), y1 = round(y + h);
      r = round(r);
      return 'M ' + (x0 + r) + ' ' + y0 + ' L ' + (x1 - r) + ' ' + y0 + ' Q ' + x1 + ' ' + y0 + ' ' + x1 + ' ' + (y0 + r) +
        ' L ' + x1 + ' ' + (y1 - r) + ' Q ' + x1 + ' ' + y1 + ' ' + (x1 - r) + ' ' + y1 +
        ' L ' + (x0 + r) + ' ' + y1 + ' Q ' + x0 + ' ' + y1 + ' ' + x0 + ' ' + (y1 - r) +
        ' L ' + x0 + ' ' + (y0 + r) + ' Q ' + x0 + ' ' + y0 + ' ' + (x0 + r) + ' ' + y0 + ' Z';
    }

    // Kiss cut: the sticker sits on a backing square (cut right through)
    // that runs kissBacking.marginMm past the sticker on every side.
    function isKiss() {
      return state.cutId === 'kiss-cut';
    }

    function backingMargin(long) {
      return isKiss() ? cfg.kissBacking.marginMm / stickerMm() * long : 0;
    }

    // Backing outline in sticker coordinates (so it starts at -margin).
    function backingPath(L, long) {
      var m = backingMargin(long);
      return rectPathAt(-m, -m, L.w + 2 * m, L.h + 2 * m, cfg.kissBacking.cornerMm / stickerMm() * long);
    }

    // --- Material looks (preview only) ----------------------------------
    // The print file is always flat artwork; these just make the on-screen
    // proof look like the chosen material.
    function foil(ctx, w, h, finish) {
      var g = ctx.createLinearGradient(0, 0, w, h);
      var stops = finish === 'chrome'
        ? ['#8a6512', '#f7e7a1', '#c99a10', '#fff6d0', '#a87c0b', '#f3d778', '#8a6512']
        : ['#ff9de2', '#fff3a0', '#9dffd6', '#9fd0ff', '#e0a8ff', '#ffb3c7', '#fff3a0', '#9dffd6'];
      stops.forEach(function (c, i) { g.addColorStop(i / (stops.length - 1), c); });
      return g;
    }

    function highlightBand(ctx, w, h, strength) {
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0.28, 'rgba(255,255,255,0)');
      g.addColorStop(0.36, 'rgba(255,255,255,' + strength + ')');
      g.addColorStop(0.44, 'rgba(255,255,255,0)');
      g.addColorStop(0.62, 'rgba(255,255,255,0)');
      g.addColorStop(0.66, 'rgba(255,255,255,' + strength * 0.6 + ')');
      g.addColorStop(0.70, 'rgba(255,255,255,0)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
    }

    var grain = null;
    function grainPattern(ctx) {
      if (!grain) {
        grain = document.createElement('canvas');
        grain.width = grain.height = 96;
        var g = grain.getContext('2d');
        var img = g.createImageData(96, 96);
        for (var i = 0; i < img.data.length; i += 4) {
          var v = Math.random() * 255;
          img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
          img.data[i + 3] = 22;
        }
        g.putImageData(img, 0, 0);
      }
      return ctx.createPattern(grain, 'repeat');
    }

    // Renders the sticker (background inside the cut line + artwork) at
    // `long` px on its longest side. Transparent outside the cut line.
    // With `preview`, the material's look is drawn on top.
    function renderSticker(long, preview) {
      var L = layout(long);
      var d = cutPath(L, long);
      var m = backingMargin(long);
      var canvas = document.createElement('canvas');
      canvas.width = Math.ceil(L.w + 2 * m);
      canvas.height = Math.ceil(L.h + 2 * m);
      var w = Math.ceil(L.w), h = Math.ceil(L.h);
      var ctx = canvas.getContext('2d');
      var path = new Path2D(d);
      if (m) {
        // the backing square (unprinted vinyl), then the sticker on top of it
        var back = new Path2D(backingPath(L, long));
        ctx.translate(m, m);
        ctx.fillStyle = '#fbfaf6';
        ctx.fill(back);
        ctx.lineWidth = Math.max(1, long * 0.002);
        ctx.strokeStyle = 'rgba(17,17,17,0.18)';
        ctx.stroke(back);
      }
      var finish = cfg.materials[state.materialIndex].finish || 'gloss';
      var whiteBg = state.backgroundId === 'white';
      ctx.save();
      ctx.clip(path);

      // Background inside the cut line. On clear, "white" means no ink.
      if (finish === 'clear' && whiteBg) {
        if (preview) {
          ctx.fillStyle = 'rgba(255,255,255,0.14)';
          ctx.fill(path);
        }
      } else if (preview && whiteBg && (finish === 'holo' || finish === 'chrome')) {
        ctx.fillStyle = foil(ctx, w, h, finish);
        ctx.fill(path);
      } else {
        ctx.fillStyle = backgroundColor();
        ctx.fill(path);
      }

      ctx.drawImage(state.image, L.artX, L.artY, L.artW, L.artH);

      if (preview) {
        if (finish === 'holo' || finish === 'chrome') {
          ctx.globalCompositeOperation = 'soft-light';
          ctx.globalAlpha = finish === 'holo' ? 0.6 : 0.4;
          ctx.fillStyle = foil(ctx, h, w, finish);
          ctx.fillRect(0, 0, w, h);
          ctx.globalCompositeOperation = 'source-over';
          ctx.globalAlpha = 1;
          highlightBand(ctx, w, h, 0.35);
        } else if (finish === 'matte') {
          ctx.fillStyle = 'rgba(255,255,255,0.07)';
          ctx.fillRect(0, 0, w, h);
          ctx.fillStyle = grainPattern(ctx);
          ctx.fillRect(0, 0, w, h);
        } else {
          highlightBand(ctx, w, h, finish === 'clear' ? 0.4 : 0.3);
        }
        if (finish === 'clear') {
          // a bright film edge, the way clear vinyl catches the light
          ctx.lineWidth = Math.max(2, long * 0.008);
          ctx.strokeStyle = 'rgba(255,255,255,0.85)';
          ctx.stroke(path);
        }
      }
      ctx.restore();
      return { canvas: canvas, path: d, backing: m ? backingPath(L, long) : null, offset: m, w: L.w + 2 * m, h: L.h + 2 * m, stickerW: L.w, stickerH: L.h };
    }

    function mountSticker(container, long, onGrid) {
      var r = renderSticker(long, true);
      container.__sp = { canvasW: r.w, canvasH: r.h, stickerW: r.stickerW, stickerH: r.stickerH };
      container.classList.toggle('sp-draggable', scalableShape());
      var finish = cfg.materials[state.materialIndex].finish;
      // Clear stickers sit on a coloured surface so you can see through them.
      container.parentNode.classList.toggle('sp-on-surface', finish === 'clear');
      container.innerHTML = '';
      // Size the box from the sticker's own proportions so tall or wide designs
      // are never stretched to fit (the canvas and cut line must line up).
      container.style.aspectRatio = r.w + ' / ' + r.h;
      container.style.setProperty('--sp-aspect', String(r.w / r.h));
      if (onGrid) {
        // Always shown large; the grid behind it is scaled so each square
        // is 1 cm at the sticker's real size.
        var stage = container.parentNode;
        var fit = stage.clientWidth * 0.86;
        var shownW = r.w >= r.h ? fit : fit * r.w / r.h;
        container.style.width = shownW + 'px';
        var pxPerMm = shownW / (r.w * stickerMm() / long);
        stage.style.backgroundSize = (pxPerMm * 10) + 'px ' + (pxPerMm * 10) + 'px';
      }
      r.canvas.className = 'sp-sticker-canvas';
      container.appendChild(r.canvas);
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('viewBox', '0 0 ' + r.canvas.width + ' ' + r.canvas.height);
      svg.setAttribute('class', 'sp-cut-line-svg');
      var addLine = function (d, cls) {
        var p = document.createElementNS(SVG_NS, 'path');
        p.setAttribute('d', d);
        p.setAttribute('vector-effect', 'non-scaling-stroke');
        if (r.offset) p.setAttribute('transform', 'translate(' + r.offset + ' ' + r.offset + ')');
        if (cls) p.setAttribute('class', cls);
        svg.appendChild(p);
      };
      if (r.backing) addLine(r.backing, 'sp-backing-line');
      addLine(r.path);
      container.appendChild(svg);
      backingLegends.forEach(function (el) { el.hidden = !r.backing; });
    }

    function renderPreviews() {
      if (!state.image) return;
      var dims = 'Actual size: ' + dimensionsText();
      els.dims.textContent = dims;
      els.proofDims.textContent = !scalableShape() ? dims + ' · border ' + fmtMm(borderMm()) : dims;
      syncBorder();
      artScaleWraps.forEach(function (w) { w.hidden = !scalableShape(); });
      syncArtScale();
      borderWraps.forEach(function (w) { w.hidden = scalableShape(); });
      mountSticker(els.previewSticker, PREVIEW_PX, true);
      if (!els.proof.hidden) {
        mountSticker(els.proofSticker, PREVIEW_PX);
        renderProofSummary();
      }
    }

    // --- Print files -----------------------------------------------------
    function canvasToBlob(canvas, type) {
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) { blob ? resolve(blob) : reject(new Error('Could not create print file')); }, type);
      });
    }

    function slug(s) {
      return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    // The print render: like renderSticker, but with the background running
    // printBleedMm past the cut line (so a slightly-off cut never shows a
    // white edge), the artwork clipped to the cut line, and a margin around
    // it all. The cut path stays in sticker coordinates; `pad` is the offset.
    function renderPrint(long) {
      var L = layout(long);
      var d = cutPath(L, long);
      var bleed = cfg.printBleedMm / stickerMm() * long;
      var pad = Math.ceil(backingMargin(long) + bleed + cfg.printMarginMm / stickerMm() * long);
      var canvas = document.createElement('canvas');
      canvas.width = Math.ceil(L.w) + pad * 2;
      canvas.height = Math.ceil(L.h) + pad * 2;
      var ctx = canvas.getContext('2d');
      var path = new Path2D(d);
      var finish = cfg.materials[state.materialIndex].finish;
      ctx.translate(pad, pad);
      if (!(finish === 'clear' && state.backgroundId === 'white')) {
        ctx.fillStyle = ctx.strokeStyle = backgroundColor();
        ctx.lineWidth = bleed * 2;
        ctx.lineJoin = 'round';
        ctx.fill(path);
        ctx.stroke(path);
      }
      // Artwork, clipped to the cut line plus the bleed, so artwork that fills
      // the shape also runs past the cut (no white sliver if the cut drifts).
      var art = document.createElement('canvas');
      art.width = canvas.width;
      art.height = canvas.height;
      var actx = art.getContext('2d');
      actx.translate(pad, pad);
      actx.drawImage(state.image, L.artX, L.artY, L.artW, L.artH);
      // the keep-area: the cut shape grown by the bleed, applied in one go
      var mask = document.createElement('canvas');
      mask.width = canvas.width;
      mask.height = canvas.height;
      var mctx = mask.getContext('2d');
      mctx.translate(pad, pad);
      mctx.fillStyle = mctx.strokeStyle = '#000';
      mctx.lineWidth = bleed * 2;
      mctx.lineJoin = 'round';
      mctx.fill(path);
      mctx.stroke(path);
      actx.setTransform(1, 0, 0, 1, 0, 0);
      actx.globalCompositeOperation = 'destination-in';
      actx.drawImage(mask, 0, 0);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(art, 0, 0);
      return { canvas: canvas, path: d, backing: isKiss() ? backingPath(L, long) : null, pad: pad, w: L.w, h: L.h };
    }

    // --- PDF for RasterLink --------------------------------------------
    // A one-page PDF: the print render as an RGB image with a soft mask
    // (transparent outside the sticker), plus the cut lines as vector paths
    // stroked at 0.25 pt in spot-colour swatches (cfg.cutLines): red
    // "CutContour" cuts right through, green "CutContourKiss" cuts the vinyl only
    // (RasterLink 7 only picks up spot colours whose names start with "CutContour").
    // Mimaki RasterLink picks the swatches up as cut paths.
    function deflate(bytes) {
      var stream = new Blob([bytes]).stream().pipeThrough(new CompressionStream('deflate'));
      return new Response(stream).arrayBuffer().then(function (buf) { return new Uint8Array(buf); });
    }

    // Our cut paths only use M, L, Q, Z, and A for full ellipses (circle /
    // oval, drawn as two half-arcs from the left middle point).
    function pdfPathOps(d, tx) {
      var t = d.trim().split(/\s+/);
      var ops = [];
      var cx = 0, cy = 0, i = 0;
      var n = function (v) { return String(Math.round(v * 1000) / 1000); };
      var pt = function (x, y) { var p = tx(x, y); return n(p[0]) + ' ' + n(p[1]); };
      var a = t.indexOf('A');
      if (a !== -1) {
        var rx = parseFloat(t[a + 1]), ry = parseFloat(t[a + 2]);
        var k = 0.5522847498, ox = rx, oy = ry; // centre of the ellipse
        ops.push(pt(ox - rx, oy) + ' m');
        ops.push(pt(ox - rx, oy - ry * k) + ' ' + pt(ox - rx * k, oy - ry) + ' ' + pt(ox, oy - ry) + ' c');
        ops.push(pt(ox + rx * k, oy - ry) + ' ' + pt(ox + rx, oy - ry * k) + ' ' + pt(ox + rx, oy) + ' c');
        ops.push(pt(ox + rx, oy + ry * k) + ' ' + pt(ox + rx * k, oy + ry) + ' ' + pt(ox, oy + ry) + ' c');
        ops.push(pt(ox - rx * k, oy + ry) + ' ' + pt(ox - rx, oy + ry * k) + ' ' + pt(ox - rx, oy) + ' c');
        ops.push('h');
        return ops.join('\n');
      }
      while (i < t.length) {
        var c = t[i++];
        if (c === 'M' || c === 'L') {
          cx = parseFloat(t[i++]); cy = parseFloat(t[i++]);
          ops.push(pt(cx, cy) + (c === 'M' ? ' m' : ' l'));
        } else if (c === 'Q') {
          // quadratic -> cubic
          var qx = parseFloat(t[i++]), qy = parseFloat(t[i++]), x = parseFloat(t[i++]), y = parseFloat(t[i++]);
          ops.push(pt(cx + 2 / 3 * (qx - cx), cy + 2 / 3 * (qy - cy)) + ' ' + pt(x + 2 / 3 * (qx - x), y + 2 / 3 * (qy - y)) + ' ' + pt(x, y) + ' c');
          cx = x; cy = y;
        } else if (c === 'Z') {
          ops.push('h');
        }
      }
      return ops.join('\n');
    }

    function buildPdf(r) {
      var w = r.canvas.width, h = r.canvas.height;
      var k = 72 / cfg.printDpi; // px -> pt
      var W = w * k, H = h * k;
      var px = r.canvas.getContext('2d').getImageData(0, 0, w, h).data;
      var rgb = new Uint8Array(w * h * 3), alpha = new Uint8Array(w * h);
      for (var i = 0, j = 0; i < w * h; i++, j += 4) {
        rgb[i * 3] = px[j]; rgb[i * 3 + 1] = px[j + 1]; rgb[i * 3 + 2] = px[j + 2];
        alpha[i] = px[j + 3];
      }
      var tx = function (x, y) { return [(x + r.pad) * k, H - (y + r.pad) * k]; };
      var stroke = function (cs, d) {
        return 'q\n/GS1 gs\n/' + cs + ' CS\n1 SCN\n' + cfg.cutLines.strokePt + ' w\n1 J\n1 j\n' + pdfPathOps(d, tx) + '\nS\nQ\n';
      };
      // CS1 = red through-cut, CS2 = green kiss cut
      var content =
        'q\n' + W.toFixed(3) + ' 0 0 ' + H.toFixed(3) + ' 0 0 cm\n/Im1 Do\nQ\n' +
        (r.backing ? stroke('CS2', r.path) + stroke('CS1', r.backing) : stroke('CS1', r.path));
      var spot = function (line) { return '[/Separation /' + line.name + ' /DeviceCMYK << /FunctionType 2 /Domain [0 1] /C0 [0 0 0 0] /C1 [' + line.cmyk.join(' ') + '] /N 1 >>]'; };
      return Promise.all([deflate(rgb), deflate(alpha)]).then(function (z) {
        var enc = new TextEncoder();
        var parts = [], offsets = [], length = 0;
        var add = function (chunk) {
          var b = typeof chunk === 'string' ? enc.encode(chunk) : chunk;
          parts.push(b);
          length += b.length;
        };
        var obj = function (num, dict, stream) {
          offsets[num] = length;
          add(num + ' 0 obj\n' + dict + '\n');
          if (stream) { add('stream\n'); add(stream); add('\nendstream\n'); }
          add('endobj\n');
        };
        var box = '[0 0 ' + W.toFixed(3) + ' ' + H.toFixed(3) + ']';
        add('%PDF-1.4\n');
        add(new Uint8Array([0x25, 0xe2, 0xe3, 0xcf, 0xd3, 0x0a])); // binary marker comment
        obj(1, '<< /Type /Catalog /Pages 2 0 R >>');
        obj(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
        obj(3, '<< /Type /Page /Parent 2 0 R /MediaBox ' + box + ' /TrimBox ' + box +
          ' /Resources << /XObject << /Im1 5 0 R >> /ColorSpace << /CS1 ' + spot(cfg.cutLines.through) + ' /CS2 ' + spot(cfg.cutLines.kiss) + ' >> /ExtGState << /GS1 8 0 R >> >>' +
          ' /Contents 4 0 R >>');
        var contentBytes = enc.encode(content);
        obj(4, '<< /Length ' + contentBytes.length + ' >>', contentBytes);
        obj(5, '<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h +
          ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /FlateDecode /SMask 6 0 R /Length ' + z[0].length + ' >>', z[0]);
        obj(6, '<< /Type /XObject /Subtype /Image /Width ' + w + ' /Height ' + h +
          ' /ColorSpace /DeviceGray /BitsPerComponent 8 /Filter /FlateDecode /Length ' + z[1].length + ' >>', z[1]);
        // (spare object, kept so the object numbers below don't change)
        obj(7, '<< >>');
        obj(8, '<< /Type /ExtGState /OP true /op true /OPM 1 >>');
        var xref = length;
        var table = 'xref\n0 9\n0000000000 65535 f \n';
        for (var o = 1; o <= 8; o++) table += String(offsets[o]).padStart(10, '0') + ' 00000 n \n';
        add(table + 'trailer\n<< /Size 9 /Root 1 0 R >>\nstartxref\n' + xref + '\n%%EOF\n');
        return new Blob(parts, { type: 'application/pdf' });
      });
    }

    // Print PNG (handy for a quick look) + the RasterLink PDF (artwork plus
    // CutContour cut line), both at printDpi with bleed.
    function buildPrintFiles() {
      var long = Math.round(stickerMm() / 25.4 * cfg.printDpi);
      var r = renderPrint(long);
      var mmW = round(r.w / cfg.printDpi * 25.4);
      var mmH = round(r.h / cfg.printDpi * 25.4);
      var base = slug(state.file.name.replace(/\.[^.]+$/, '')) || 'sticker';
      var tag = base + '-' + slug(fmtCm(stickerMm()) + 'cm') + '-' + slug(effectiveShape());
      return Promise.all([canvasToBlob(r.canvas, 'image/png'), buildPdf(r)]).then(function (out) {
        return {
          png: new File([out[0]], tag + '-print.png', { type: 'image/png' }),
          pdf: new File([out[1]], tag + '-print-and-cut.pdf', { type: 'application/pdf' }),
          mm: mmW + ' × ' + mmH + ' mm',
        };
      });
    }

    // --- Proof modal -----------------------------------------------------
    function renderProofSummary() {
      var qty = cfg.quantities[state.quantityIndex];
      els.proofSummary.textContent =
        qty.amount.toLocaleString('en-GB') + ' × ' + cfg.materials[state.materialIndex].name + ', ' +
        dimensionsText() + ', ' + byId(cfg.cuts, state.cutId).label.toLowerCase();
    }

    // Actual printed width × height of the sticker, from its shape.
    function dimensionsText() {
      var L = layout(1000);
      var mm = stickerMm();
      var text = fmtCm(L.w / 1000 * mm) + ' × ' + fmtCm(L.h / 1000 * mm) + ' cm';
      if (isKiss()) text += ' on a ' + backingSizeText(L, 1000) + ' backing';
      return text;
    }

    function backingSizeText(L, long) {
      var mm = stickerMm(), m = backingMargin(long);
      return fmtCm((L.w + 2 * m) / long * mm) + ' × ' + fmtCm((L.h + 2 * m) / long * mm) + ' cm';
    }

    function openProof() {
      if (!state.image) return;
      els.proof.hidden = false;
      document.documentElement.classList.add('sp-proof-open');
      setStatus(els.proofStatus, '');
      renderPreviews();
      els.approve.focus({ preventScroll: true });
      els.proof.querySelector('.sp-proof-panel').scrollTop = 0; // phones: start at the sticker, not the buttons
    }

    function closeProof() {
      els.proof.hidden = true;
      document.documentElement.classList.remove('sp-proof-open');
    }

    // While the order is being added, a full-screen overlay says what's happening:
    // on phones the status line under the buttons is usually off-screen.
    function setBusy(busy, message) {
      [els.approve, els.addOnly].forEach(function (b) { b.disabled = busy; });
      if (els.busy) {
        els.busy.hidden = !busy;
        if (message) els.busyText.textContent = message;
      }
    }

    // The order line's properties (what the print team sees), apart from the files.
    function lineProperties(files) {
      var shape = byId(cfg.shapes, state.shapeId);
      var bg = byId(cfg.backgrounds, state.backgroundId);
      var p = [];
      p.push(['Cut', byId(cfg.cuts, state.cutId).label]);
      p.push(['Shape', effectiveShape() === state.shapeId ? shape.label : shape.label + ' (rectangle, no transparency)']);
      if (hasCorners()) p.push(['Corners', byId(cfg.corners, state.cornersId).label]);
      if (!scalableShape()) p.push(['Border', fmtMm(borderMm())]);
      if (state.customMm) p.push(['Custom size', fmtCm(state.customMm) + ' cm longest side']);
      if (scalableShape()) {
        var AL = layout(1000);
        p.push(['Artwork size', AL.pct + '% of edge to edge']);
        var mx = Math.round(state.artOffset.x * AL.w / 1000 * stickerMm()), my = Math.round(state.artOffset.y * AL.h / 1000 * stickerMm());
        if (mx || my) {
          p.push(['Artwork position', 'Moved ' + [mx ? Math.abs(mx) + ' mm ' + (mx > 0 ? 'right' : 'left') : '', my ? Math.abs(my) + ' mm ' + (my > 0 ? 'down' : 'up') : ''].filter(Boolean).join(', ') +
            ' (pos=' + state.artOffset.x.toFixed(3) + ',' + state.artOffset.y.toFixed(3) + ')']);
        }
      }
      p.push(['Background', bg.id === 'custom' ? state.customColor : bg.label]);
      p.push(['Print size', files.mm]);
      if (isKiss()) p.push(['Backing size', backingSizeText(layout(1000), 1000)]);
      if (state.useCutout) p.push(['Background removed', 'Yes, automatically']);
      var notes = els.notes.value.trim();
      if (notes) p.push(['Proof changes', notes]);
      return p;
    }

    function addToCart(goToCheckout) {
      setBusy(true, 'Preparing your print files…');
      setStatus(els.proofStatus, '');
      variantsReady
        .then(function () {
          var variant = findVariant(state.materialIndex, state.sizeIndex, state.quantityIndex);
          if (!variant) throw new Error('This option isn\'t available to order yet. Please try another or contact us.');
          if (!variant.available) throw new Error('This option is sold out right now.');
          return buildPrintFiles().then(function (files) { return { variant: variant, files: files }; });
        })
        .then(function (x) {
          setBusy(true, 'Uploading your artwork…');
          var fd = new FormData();
          fd.append('id', x.variant.id);
          fd.append('quantity', '1');
          lineProperties(x.files).forEach(function (p) { fd.append('properties[' + p[0] + ']', p[1]); });
          // .ai files go up as .ai.pdf: Shopify's file uploads are only known
          // to take PDFs, and a PDF-compatible .ai opens fine as either.
          var artwork = /\.ai$/i.test(state.file.name)
            ? new File([state.file], state.file.name + '.pdf', { type: 'application/pdf' })
            : state.file;
          fd.append('properties[Artwork]', artwork, artwork.name);
          fd.append('properties[Print file]', x.files.png, x.files.png.name);
          fd.append('properties[Print and cut file (RasterLink PDF)]', x.files.pdf, x.files.pdf.name);
          return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              throw new Error(body.description || body.message || 'Add to cart failed (' + res.status + ')');
            });
          }
          return res.json();
        })
        .then(function () {
          if (goToCheckout) {
            setBusy(true, 'Taking you to checkout…');
            window.location.href = '/checkout';
            return;
          }
          setBusy(false);
          setStatus(els.proofStatus, '');
          closeProof();
          setStatus(els.status, 'Added to your cart! Upload another design or check out from the cart.', 'ok');
          document.dispatchEvent(new CustomEvent('sticker:added-to-cart'));
        })
        .catch(function (err) {
          setBusy(false);
          setStatus(els.proofStatus, err.message || 'Something went wrong adding this to your cart.', 'error');
        });
    }

    // --- Wiring ----------------------------------------------------------
    function pickFile() { els.fileInput.value = ''; els.fileInput.click(); }
    els.dropzone.addEventListener('click', pickFile);
    els.uploadBtn.addEventListener('click', pickFile);
    els.swap.addEventListener('click', pickFile);
    els.fileInput.addEventListener('change', function (e) { handleFile(e.target.files[0]); });
    [els.dropzone, els.uploadBtn, els.canvasWrap].forEach(function (zone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.add('sp-drag-over'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        zone.addEventListener(evt, function (e) { e.preventDefault(); zone.classList.remove('sp-drag-over'); });
      });
      zone.addEventListener('drop', function (e) { handleFile(e.dataTransfer.files[0]); });
    });
    // Upload buttons elsewhere on the page (e.g. the hero) use this builder's
    // file picker, then bring the builder into view with the design loaded.
    var scrollAfterUpload = false;
    document.querySelectorAll('[data-sp-upload-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollAfterUpload = true;
        pickFile();
      });
    });
    els.fileInput.addEventListener('change', function () {
      if (scrollAfterUpload) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      scrollAfterUpload = false;
    });

    // Material links (materials section, footer): pick that material here
    // instead of reloading the page.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-sp-material]');
      if (!link) return;
      var name = link.getAttribute('data-sp-material');
      var index = cfg.materials.map(function (m) { return m.name; }).indexOf(name);
      if (index === -1) return;
      e.preventDefault();
      state.materialIndex = index;
      refreshAll();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Custom size: charged at the smallest size band at least that big.
    els.customSize.min = cfg.customSize.minMm / 10;
    els.customSize.max = cfg.customSize.maxMm / 10;
    els.customSize.addEventListener('input', function () {
      var raw = els.customSize.value.trim();
      if (!raw) {
        if (state.customMm && state.sizeBeforeCustom != null) state.sizeIndex = state.sizeBeforeCustom;
        state.customMm = null;
        els.customSizeNote.textContent = '';
        refreshAll();
        return;
      }
      var mm = Math.round(parseFloat(raw) * 10);
      if (!(mm >= cfg.customSize.minMm && mm <= cfg.customSize.maxMm)) {
        els.customSizeNote.textContent = 'Choose between ' + fmtCm(cfg.customSize.minMm) + ' and ' + fmtCm(cfg.customSize.maxMm) + ' cm.';
        els.customSizeNote.className = 'sp-hint sp-error-text';
        return;
      }
      if (!state.customMm) state.sizeBeforeCustom = state.sizeIndex; // to go back to if they clear it
      state.customMm = mm;
      for (var i = 0; i < cfg.sizes.length; i++) {
        if (cfg.sizes[i].mm >= mm) { state.sizeIndex = i; break; }
      }
      els.customSizeNote.className = 'sp-hint';
      els.customSizeNote.textContent = 'Priced as ' + cfg.sizes[state.sizeIndex].label + '.';
      refreshAll();
    });

    artScaleInputs.forEach(function (input) {
      input.min = cfg.artworkScale.min;
      input.max = cfg.artworkScale.max;
      input.addEventListener('input', function () {
        state.artScale = Number(input.value);
        syncArtScale();
        renderPreviews();
      });
    });
    syncArtScale();

    // Drag the artwork to move it (every shape except custom shape).
    root.querySelectorAll('[data-sp-recentre]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.artOffset = { x: 0, y: 0 };
        renderPreviews();
      });
    });
    var dragFrame = null;
    function redrawSoon() {
      if (dragFrame) return;
      dragFrame = setTimeout(function () { dragFrame = null; renderPreviews(); }, 16);
    }
    [els.previewSticker, els.proofSticker].forEach(function (box) {
      var drag = null;
      box.addEventListener('pointerdown', function (e) {
        if (!state.image || !scalableShape() || !box.__sp) return;
        e.preventDefault();
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, start: { x: state.artOffset.x, y: state.artOffset.y } };
        try { box.setPointerCapture(e.pointerId); } catch (err) { /* keep dragging without capture */ }
        box.classList.add('sp-dragging');
      });
      box.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var rect = box.getBoundingClientRect(), m = box.__sp;
        // screen px -> fraction of the sticker (the box also shows any backing sheet)
        var fx = (e.clientX - drag.x) / rect.width * (m.canvasW / m.stickerW);
        var fy = (e.clientY - drag.y) / rect.height * (m.canvasH / m.stickerH);
        var clamp = function (v) { return Math.max(-0.5, Math.min(0.5, v)); }; // keep the artwork's centre on the sticker
        state.artOffset = { x: clamp(drag.start.x + fx), y: clamp(drag.start.y + fy) };
        redrawSoon();
      });
      var end = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        drag = null;
        box.classList.remove('sp-dragging');
      };
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
    });

    borderInputs.forEach(function (input) {
      input.min = cfg.border.minMm;
      input.max = cfg.border.maxMm;
      input.step = cfg.border.stepMm;
      input.addEventListener('input', function () {
        state.borderRatio = Number(input.value) / stickerMm();
        syncBorder();
        renderPreviews();
      });
    });
    syncBorder();

    // The to-scale preview depends on the box width, so redraw on resize.
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(renderPreviews, 150);
    });

    els.openProof.addEventListener('click', openProof);
    els.proofClose.addEventListener('click', closeProof);
    els.proof.addEventListener('click', function (e) { if (e.target === els.proof) closeProof(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !els.proof.hidden) closeProof(); });
    els.approve.addEventListener('click', function () { if (check) submitCheck(); else addToCart(true); });
    els.addOnly.addEventListener('click', function () { addToCart(false); });
    els.requestToggle.addEventListener('click', function () {
      els.request.hidden = !els.request.hidden;
      if (!els.request.hidden) els.notes.focus();
    });

    // Move the modal to <body> so no ancestor's transform/overflow traps it.
    document.body.appendChild(els.proof);

    buildOptionGrids();
    renderPrice();
    loadReorder();
    setupCheck();

    // --- Artwork check ---------------------------------------------------
    // ?check=<token> with a reorder link: the print team flagged this sticker
    // and emailed the customer. Their order is loaded as they built it.
    // Material, size, quantity and cut are paid for, so they're locked; the
    // artwork, shape, corners, border and artwork size/position can change.
    // Approving sends the print files of exactly what they approved (and any
    // new artwork) to the print team, instead of adding to the cart.
    // `check` comes from the URL, near the top.

    function setupCheck() {
      if (!check) return;
      root.classList.add('sp-check-mode');
      [els.materialGrid, els.sizeGrid, els.qtyList].forEach(function (el) {
        var block = el && el.closest('.sp-choice');
        if (block) block.hidden = true;
      });
      els.cutGrid.hidden = true;
      els.addOnly.hidden = true;
      els.approve.textContent = 'Approve and print →';
      var note = q('.sp-note');
      if (note) note.textContent = 'Open your proof to approve it or make changes.';
      check.banner = document.createElement('div');
      check.banner.className = 'sp-check-banner';
      check.banner.innerHTML = '<b>Loading your order…</b>';
      root.insertBefore(check.banner, q('.sp-card'));
      fetch(cfg.checkUrl + '?action=check&token=' + encodeURIComponent(check.token))
        .then(function (res) { return res.json(); })
        .then(function (c) {
          if (!c.ok) throw new Error();
          if (c.status !== 'waiting') {
            closeCheck('<b>Order ' + escapeHtml(c.order) + '</b><p>Thanks, we already have your answer for this sticker, so there\'s nothing more to do. Questions? Email <a href="mailto:info@stickerpack.co.uk">info@stickerpack.co.uk</a>.</p>');
            return;
          }
          check.banner.innerHTML = '<b>Order ' + escapeHtml(c.order) + ': please check your sticker</b>' +
            '<p class="sp-check-note">Our print team flagged: “' + escapeHtml(c.note) + '”</p>' +
            '<p>Your sticker is loaded below as you ordered it. Open the proof: if it looks right, press <b>Approve and print</b>. ' +
            'To fix it, upload different artwork, change the shape, or move and resize the artwork, then approve. Your material, size and quantity stay as ordered.</p>';
        })
        .catch(function () {
          closeCheck('<b>We couldn\'t open this check.</b><p>Please reply to our email, or email <a href="mailto:info@stickerpack.co.uk">info@stickerpack.co.uk</a>, and we\'ll sort it out.</p>');
        });
    }

    function closeCheck(html) {
      check.closed = true;
      check.banner.innerHTML = html;
      q('.sp-card').hidden = true;
      closeProof();
    }

    function fileData(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve({ name: file.name, type: file.type, data: String(reader.result).split(',')[1] }); };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function submitCheck() {
      if (check.closed) return;
      setBusy(true, 'Preparing your print files…');
      setStatus(els.proofStatus, '');
      buildPrintFiles()
        .then(function (files) {
          setBusy(true, 'Sending your sticker to our print team…');
          var newArt = state.file !== state.originalFile;
          return Promise.all([fileData(files.pdf), fileData(files.png), newArt ? fileData(state.file) : null]).then(function (d) {
            // text/plain keeps this a simple request, which Apps Script accepts from any site.
            return fetch(cfg.checkUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'text/plain;charset=utf-8' },
              body: JSON.stringify({
                action: 'check-reply', token: check.token, message: els.notes.value.trim(), properties: lineProperties(files),
                files: { pdf: d[0], png: d[1], artwork: d[2] || undefined },
              }),
            });
          });
        })
        .then(function (res) { return res.json(); })
        .then(function (r) {
          setBusy(false);
          if (!r.ok) throw new Error(r.error || 'Something went wrong. Please try again.');
          closeCheck('<b>Thank you!</b><p>' + (r.status === 'changed' ? 'We\'ve got your new artwork' : 'Your sticker is approved') +
            ' and it\'s going to print. You don\'t need to do anything else.</p>');
          root.scrollIntoView({ block: 'start' });
        })
        .catch(function (err) {
          setBusy(false);
          setStatus(els.proofStatus, err.message || 'Something went wrong. Please try again.', 'error');
        });
    }

    // --- Reorder ---------------------------------------------------------
    // "Reorder this design" links in the order emails reopen the builder with
    // the same options and the customer's original artwork:
    // ?reorder=1&v=<variant title>&cut=&shape=&border=&bg=&custom=&artsize=&artpos=&art=<Shopify file URL>
    function loadReorder() {
      var art = params.get('art') || '';
      if (!params.get('reorder') || !/^https:\/\/cdn\.shopify\.com\//.test(art)) return;
      var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
      var find = function (list, keys, value) {
        for (var i = 0; i < list.length; i++) {
          for (var k = 0; k < keys.length; k++) if (norm(list[i][keys[k]]) === norm(value)) return i;
        }
        return -1;
      };
      var v = (params.get('v') || '').split(' / ');
      var mat = find(cfg.materials, ['name'], v[0]);
      if (mat > -1) state.materialIndex = mat;
      var size = find(cfg.sizes, ['label', 'name'], v[1]);
      if (size > -1) state.sizeIndex = size;
      var amount = parseInt(String(v[2] || '').replace(/[^0-9]/g, ''), 10);
      var qty = cfg.quantities.map(function (x) { return x.amount; }).indexOf(amount);
      if (qty > -1) state.quantityIndex = qty;
      var cut = find(cfg.cuts, ['label', 'id'], params.get('cut'));
      if (cut > -1) state.cutId = cfg.cuts[cut].id;
      var shape = find(cfg.shapes, ['label', 'id'], String(params.get('shape') || '').split(' (')[0]);
      if (shape > -1) state.shapeId = cfg.shapes[shape].id;
      var customMm = Math.round(parseFloat(params.get('custom')) * 10);
      if (customMm >= cfg.customSize.minMm && customMm <= cfg.customSize.maxMm) {
        state.customMm = customMm;
        els.customSize.value = customMm / 10;
      }
      var border = parseFloat(params.get('border'));
      if (border > 0) state.borderRatio = border / stickerMm();
      var bg = params.get('bg') || '';
      if (/^#[0-9a-f]{6}$/i.test(bg)) {
        state.backgroundId = 'custom';
        state.customColor = bg;
      } else {
        var b = find(cfg.backgrounds, ['label', 'id'], bg);
        if (b > -1) state.backgroundId = cfg.backgrounds[b].id;
      }
      var artSize = parseInt(params.get('artsize'), 10);
      if (artSize >= cfg.artworkScale.min && artSize <= cfg.artworkScale.max) state.pendingArtScale = artSize;
      state.pendingCutout = params.get('cutout');
      var corners = find(cfg.corners, ['label', 'id'], params.get('corners'));
      if (corners > -1) state.cornersId = cfg.corners[corners].id;
      var pos = /pos=(-?[\d.]+),(-?[\d.]+)/.exec(params.get('artpos') || '');
      if (pos) state.pendingArtOffset = { x: Number(pos[1]), y: Number(pos[2]) };
      refreshAll();
      syncBorder();

      setStatus(els.status, 'Loading your previous design…', '');
      root.scrollIntoView({ block: 'start' });
      fetch(art)
        .then(function (res) {
          if (!res.ok) throw new Error();
          return res.blob();
        })
        .then(function (blob) {
          var name = decodeURIComponent(art.split('?')[0].split('/').pop()) || 'artwork';
          var type = blob.type || (/\.pdf$/i.test(name) ? 'application/pdf' : 'image/png');
          state.reorderNote = true;
          state.originalFile = new File([blob], name, { type: type });
          handleFile(state.originalFile);
        })
        .catch(function () {
          setStatus(els.status, 'We couldn\'t load your previous artwork. Please upload it again.', 'error');
        });
    }

    return { getState: function () { return state; } };
  }

  function init() {
    var instances = [];
    document.querySelectorAll('[data-sp-configurator]').forEach(function (root) {
      instances.push(initInstance(root));
    });
    return instances;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.StickerBuilder = { instances: init() };
    });
  } else {
    window.StickerBuilder = { instances: init() };
  }
})();
